import {
  Globe,
  Coffee,
  Camera,
  Heart,
  Users,
  Award,
  MapPin,
  Calendar,
  ArrowRight,
  Instagram,
  Facebook,
  // Add more icons as needed
} from "lucide-react";

// Map icon names from Directus to Lucide React icons
export const iconMap = {
  // Original mappings
  globe: Globe,
  coffee: Coffee,
  camera: Camera,
  heart: Heart,
  users: Users,
  award: Award,
  map: MapPin,
  calendar: Calendar,
  arrow: ArrowRight,
  instagram: Instagram,
  facebook: Facebook,

  // New mappings from your data
  globe_asia: Globe,
  local_cafe: Coffee,
  photo_camera: Camera,

  // Add more mappings as needed
};

/**
 * Get a Lucide icon component from a string name
 * @param {string} iconName - The icon name from Directus
 * @returns {React.ComponentType} - The corresponding Lucide icon component
 */
export function getIcon(iconName) {
  if (!iconName) return Globe; // Default fallback

  const normalizedName = iconName.toLowerCase().trim();
  return iconMap[normalizedName] || Globe;
}
